import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db, auth } from "../firebase";
import { Bar } from "react-chartjs-2";
import { useNavigate } from "react-router-dom";


import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import BackHomeButton from "../components/BackHomeButton";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

const UserQuizPerformance = () => {
  const [results, setResults] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");

  const [hoveredButton, setHoveredButton] = useState(null);
  const [overallStats, setOverallStats] = useState({});


  const startDate = new Date("2026-01-01T00:00:00");


  const navigate = useNavigate();

  const fetchProfileAndResults = async () => {
  const user = auth.currentUser;
  if (!user) return;

   const BLOCKED_UID = "RqxiqS2jrGgvmIdAfbcHEIDhkkG2"; 


  // 🔹 Get CURRENT profile
  const profileSnap = await getDocs(
    query(
      collection(db, "profiles"),
      where("uid", "==", user.uid)
    )
  );

  if (profileSnap.empty) return;

  const profile = profileSnap.docs[0].data();
  const { school, standard, uid } = profile;

  //alert(school);
  //alert(standard);

  const allClassResultsSnap = await getDocs(
  query(
    collection(db, "AI_Results"),
    where("school", "==", school),
    where("standard", "==", standard)
  )
);

//alert(allClassResultsSnap.docs.length);

const allClassResults = allClassResultsSnap.docs.map(d => d.data())
.filter(d => d.uid !== BLOCKED_UID);

//alert(allClassResults.length);

// Build dropdown from all class results
const subjectsFromClass = [
  ...new Set(
    allClassResults
      .filter(d => d.timestamp?.toDate() >= startDate)
      .map(d => d.subject)
  )
];

setSubjectList(subjectsFromClass);


  const allResultsSnap = await getDocs(
  query(
    collection(db, "AI_Results"),
    where("school", "==", school),
    where("standard", "==", standard),
    where("subject", "==", selectedSubject)
  )
);



const allResults = allResultsSnap.docs
  .map(d => d.data())
  .filter(d => d.uid !== BLOCKED_UID);

const overallGrouped = {};

allResults.forEach(r => {

  // ⏳ ONLY last 6 months (same as user data)
  if (!r.timestamp || r.timestamp.toDate() < startDate) return;

  const key = `${r.subject || "Unknown"} | ${r.lesson || "Unknown"} | ${r.topic || "Unknown"}`;


if (!overallGrouped[key]) {
    overallGrouped[key] = {
      total: 0,
      count: 0,
      scores: [],
      userSet: new Set(), // track unique users
    };
  }

  overallGrouped[key].total += r.score;
  overallGrouped[key].count += 1;
  overallGrouped[key].scores.push(r.score);
  overallGrouped[key].userSet.add(r.uid); // add user to set
});

const computedOverallStats = {};
Object.keys(overallGrouped).forEach(key => {
  const g = overallGrouped[key];

  computedOverallStats[key] = {
    overallAvg: g.total / g.count,
    maxAvg: Math.max(...g.scores),
    minAvg: Math.min(...g.scores),
    userCount: g.userSet.size, // number of users attempted
  };
});

setOverallStats(computedOverallStats);// 👈 THIS WAS MISSING

  const resultsSnap = await getDocs(
    query(
      collection(db, "AI_Results"),
      where("uid", "==", uid),
      where("school", "==", school),
      where("standard", "==", standard)
    )
  );

  const data = resultsSnap.docs.map(doc => doc.data());

  setResults(data);

};

useEffect(() => {
  fetchProfileAndResults();
}, [selectedSubject]);


const filteredResults = results.filter(
  r => r.subject === selectedSubject 
  && r.timestamp?.toDate() >= startDate
);

const groupedData = {};

filteredResults.forEach(r => {
  const key = `${r.subject || "Unknown"} | ${r.lesson || "Unknown"} | ${r.topic || "Unknown"}`;


  if (!groupedData[key]) {
    groupedData[key] = {
      totalScore: 0,
      count: 0,
    };
  }

  groupedData[key].totalScore += r.score;
  groupedData[key].count += 1;
});

const mergedResults = Object.keys(overallStats).map(key => {
  const userData = groupedData[key]; // may be undefined if user didn't attempt

  // split key: "subject | lesson | topic"
  const parts = key.split(" | ");
  const lessonTopicLabel = `${parts[1]} | ${parts[2]}`; // remove subject

  return {
    label: lessonTopicLabel,        // chart label
    avgScore: userData ? userData.totalScore / userData.count : 0, // user's score or 0
    overallAvg: overallStats[key].overallAvg,
    maxAvg: overallStats[key].maxAvg,
    minAvg: overallStats[key].minAvg,
    userCount: overallStats[key].userCount,
  };
});





  const chartRows = mergedResults;

  const open_quiz_dashboard = async () => {

      window.open(
          "https://lookerstudio.google.com/reporting/c7cb2ba2-37f1-4a65-9832-170fc9569235?authuser="
      );
  
  };

const handleGenerateWorksheet = (row) => {
  navigate("/Eascode_Agent_Lesson", {
    state: {
      subject: selectedSubject,
      lesson: row.label.split(" | ")[0],
      topic: row.label.split(" | ")[1],
    },
  });
};

const handleTakeQuiz = (row) => {
  navigate("/AIQuestionTest", {
    state: {
      subject: selectedSubject,
      lesson: row.label.split(" | ")[0],
      topic: row.label.split(" | ")[1],
    },
  });
};



{/*
const chartData = {
  labels: averagedResults.map(r => r.label),
  datasets: [
    {
      label: "Average Marks",
      data: averagedResults.map(r => r.avgScore),
      backgroundColor: "#1976d2", // blue
      borderColor: "#1976d2",
      borderWidth: 1,
    },
  ],
};
*/}

const chartData = {
  labels: mergedResults.map(r => r.label),
  datasets: [
    {
      label: "My Average",
      data: mergedResults.map(r => r.avgScore),
      backgroundColor: "#1976d2", // blue
      borderColor: "#1976d2",
      borderWidth: 1,
    },
    {
      label: "Class Overall Average",
      data: mergedResults.map(r => r.overallAvg),
      backgroundColor: "#19d22c", // blue
      borderColor: "#19d22c",
      borderWidth: 1,
    },
    {
      label: "Class Max Score",
      data: mergedResults.map(r => r.maxAvg),
      backgroundColor: "#d2193b", // blue
      borderColor: "#d2193b",
      borderWidth: 1,
    },
    {
      label: "Class Min Score",
      data: mergedResults.map(r => r.minAvg),
      backgroundColor: "#dfdc3a", // blue
      borderColor: "#dfdc3a",
      borderWidth: 1,
    }
  ],
};



const [selectedBar, setSelectedBar] = useState(null);

// inside chart options
const chartOptions = {
  responsive: true,
  indexAxis: "y",
  plugins: {
    legend: { display: true },
  },
  onClick: (evt, elements) => {
    if (elements.length > 0) {
      const index = elements[0].index; // index of clicked bar
      setSelectedBar(chartRows[index]);
    }
  },
  scales: {
    x: {
      beginAtZero: true,
      min: 0,
      max: 20,            // 👈 FIXED MARKS SCALE
      ticks: {
        stepSize: 2,      // optional (0,2,4...20)
      },
      title: {
        display: true,
        text: "Average Marks (out of 20)",
      },
    },
y: {
  title: {
    display: true,
    text: "Lesson / Topic",
  },
  ticks: {
    callback: function (value) {
      const label = this.getLabelForValue(value);
      return label.split(" | "); // 👈 splits into 2 lines
    },
  },
},
  },
};



return (
    <div className="min-h-screen bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-indigo-50 via-slate-50 to-white py-4 sm:py-8 px-3 sm:px-6 lg:px-8 font-sans">
      
      {/* Dashboard Container */}
      <div className="w-full max-w-5xl mx-auto bg-white/80 backdrop-blur-xl rounded-[1.5rem] sm:rounded-[2rem] shadow-2xl shadow-indigo-500/10 border border-white p-4 sm:p-8">
        
        {/* Top Nav & Header */}
        <div className="flex items-center justify-between mb-6 sm:mb-8 gap-2">
          <div className="flex-1 flex justify-start min-w-0">
            <BackHomeButton />
          </div>
          <div className="flex-auto text-center px-1 sm:px-4 shrink-0">
            <h2 className="text-lg sm:text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight leading-tight">
              📊 My Quiz <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-violet-600">Performance</span>
            </h2>
          </div>
          <div className="flex-1 min-w-0"></div>
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-4 mb-6 sm:mb-8 text-center text-[10px] sm:text-xs">
          <div className="bg-slate-50 border border-slate-200 p-3 sm:p-4 rounded-xl shadow-sm">
            <p className="text-slate-600 font-medium">Select a subject to view your performance across lessons and topics since <strong>01-Jan-2026</strong>.</p>
          </div>
          <div className="bg-slate-50 border border-slate-200 p-3 sm:p-4 rounded-xl shadow-sm">
            <p className="text-slate-600 font-medium">Click on any <strong className="text-indigo-600">bar in the chart</strong> below to generate a targeted worksheet or quiz.</p>
          </div>
          <div className="bg-slate-50 border border-slate-200 p-3 sm:p-4 rounded-xl shadow-sm">
             <p className="text-slate-600 font-medium">For comprehensive historic data, click the <strong className="text-emerald-600">Dashboard</strong> button below.</p>
          </div>
        </div>

        {/* Configuration Controls */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mb-8 bg-indigo-50/50 p-4 sm:p-5 rounded-2xl border border-indigo-100">
          <div className="w-full sm:flex-1 space-y-1 sm:space-y-2">
            <label className="block text-[11px] sm:text-sm font-bold text-indigo-900 ml-1 uppercase tracking-widest">Select Subject</label>
            <select
              value={selectedSubject}
              onChange={(e) => setSelectedSubject(e.target.value)}
              className="w-full bg-white border-2 border-indigo-100 hover:border-indigo-300 rounded-xl px-3 py-2.5 sm:px-4 sm:py-3 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 transition-all outline-none text-xs sm:text-sm font-bold text-slate-700 cursor-pointer shadow-sm"
            >
              <option value="">-- Choose Subject --</option>
              {subjectList.map((s, i) => (
                <option key={i} value={s}>{s}</option>
              ))}
            </select>
          </div>

          <div className="w-full sm:w-auto self-end">
             <button
                onClick={() => {
                  if (auth.currentUser?.email === "eascode.ltd@gmail.com") {
                    navigate('/ParentPortalDashboard');
                  } else {
                    open_quiz_dashboard();
                  }
                }}
                className="w-full sm:w-auto bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-bold py-2.5 sm:py-3 px-5 sm:px-6 rounded-xl shadow-lg hover:shadow-emerald-500/30 hover:scale-[1.02] transition-all text-[11px] sm:text-sm whitespace-nowrap"
              >
                {auth.currentUser?.email === "eascode.ltd@gmail.com"
                  ? "⚙️ Parent Portal Dashboard"
                  : "📈 Advanced Analytics Dashboard"}
              </button>
          </div>
        </div>

        {/* Chart Area */}
        {selectedSubject && chartRows.length > 0 && (
          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-2 sm:p-6 mb-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="w-full overflow-x-auto custom-scrollbar pb-4">
              <div className="min-w-[600px]">
                 <Bar data={chartData} options={chartOptions} />
              </div>
            </div>

            {/* Contextual Actions for Selected Bar */}
            {selectedBar && (
              <div className="mt-6 p-4 sm:p-5 bg-slate-900 rounded-xl sm:rounded-2xl shadow-inner flex flex-col sm:flex-row items-center justify-between gap-4 animate-in zoom-in-95 duration-200">
                <div className="text-white text-center sm:text-left">
                   <p className="text-[10px] sm:text-xs font-bold text-indigo-300 uppercase tracking-widest mb-1">Targeted Action Required</p>
                   <p className="text-sm sm:text-base font-bold leading-tight">{selectedBar.label}</p>
                </div>
                
                <div className="flex gap-2 sm:gap-3 w-full sm:w-auto">
                  <button 
                    onClick={() => handleGenerateWorksheet(selectedBar)}
                    className="flex-1 sm:flex-none bg-indigo-500 hover:bg-indigo-400 text-white font-bold py-2 sm:py-2.5 px-3 sm:px-5 rounded-lg sm:rounded-xl shadow-md transition-colors text-[10px] sm:text-sm"
                  >
                    📄 Generate Worksheet
                  </button>
                  <button 
                    onClick={() => handleTakeQuiz(selectedBar)}
                    className="flex-1 sm:flex-none bg-rose-500 hover:bg-rose-400 text-white font-bold py-2 sm:py-2.5 px-3 sm:px-5 rounded-lg sm:rounded-xl shadow-md transition-colors text-[10px] sm:text-sm"
                  >
                    🎯 Take Quiz
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Empty State */}
        {selectedSubject && mergedResults.length === 0 && (
          <div className="text-center bg-rose-50 border border-rose-100 rounded-2xl p-8 sm:p-12 mb-6">
            <span className="text-3xl sm:text-5xl mb-3 block">📭</span>
            <p className="text-rose-600 font-bold text-sm sm:text-lg">No quiz data found for {selectedSubject}.</p>
            <p className="text-rose-400 text-xs sm:text-sm mt-1">Take a quiz first to populate your performance chart.</p>
          </div>
        )}

      </div>
    </div>
  );
};



export default UserQuizPerformance;
